import { url } from "../axios/api";

export const fileUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return url.replace(/\/public\/index\.php$/, "") + path;
};
